export const parseIdList = (value) => {
  if (value === null || value === undefined || value === "") return [];

  if (Array.isArray(value)) {
    return value
      .map((id) => Number(id))
      .filter((id) => !Number.isNaN(id) && Number.isInteger(id));
  }

  return String(value)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => Number(part))
    .filter((id) => !Number.isNaN(id) && Number.isInteger(id));
};

export const parsePackageIds = parseIdList;
export const parsePlatformIds = parseIdList;
